import { Button } from '@hive/component';
import { useI18n } from '@hive/i18n';

import * as styles from './tag-list-header.css';

export const TagListHeader = ({ onOpen }: { onOpen: () => void }) => {
  const t = useI18n();
  return (
    <div className={styles.tagListHeader}>
      <div className={styles.tagListHeaderTitle}>{t['Tags']()}</div>
      <Button
        className={styles.newTagButton}
        onClick={onOpen}
        data-testid="all-tags-new-button"
      >
        {t['com.hive.tags.empty.new-tag-button']()}
      </Button>
    </div>
  );
};
